<template>
    <div class="all">
        <div class="screen">
            <h2>{{title}}</h2>
        </div>
        <div class="warp mt20 clearfix">
            <div class="warp-body">
                 <div class="no-data pt30" v-if="nodata"><img :src="$parent.baseUrl+'/static/images/no_data.png'" class="img"/><span class="text">没有数据哦...</span></div>
                <ul class="article-list mt10">
                    <li class="imgText clearfix" v-for="(item,index) in topicsList" :key="index">
                        <router-link :to="{path:''+$parent.baseUrl+'/eventDetail',query:{id:item.id}}" target="_blank">
                            <img :src="[item.icon]" class="img fl" :onerror="defaultImg"/>
                        </router-link>
                        <div class="hidden">
                            <div class="clearfix">
                                <h2 class="fl"><router-link class="cr3d" :to="{path:''+$parent.baseUrl+'/eventDetail',query:{id:item.id}}" target="_blank">{{item.name}}</router-link></h2>
                                <span class="fr">舆情指数 <strong class="color-blue fs18">{{item.exponent}}</strong></span>
                            </div>
                            <p class="mt5 ovhidden5">{{item.schemeDescription}}</p>
                        </div>
                    </li>
                    
                </ul>
                <div class="mt20 ac" v-if="isShowMore">
                    <a class="more color-8a8a99" href="javascript:void(0);" @click="showMore">点击加载更多</a>
                </div>
                <div class="mt20 ac" v-if="isShowEnd">
                    <a class="more color-8a8a99" href="javascript:void(0);">数据已经全部加载完成啦~</a>
                </div>
            </div>
        </div>
	</div>
</template>
<script>
export default {
    data() {
        return {
            typeId : this.$route.query.id, 
            title : this.$route.query.name, 
            topicsList:[],
            pageCur:1,
            pageNum:4,
            dataCount:0,
            defaultImg:'this.src="'+this.$parent.baseUrl+'/static/images/default.png"',
            isShowMore:false,
            isShowEnd:false,
            nodata:false
        }
    },
    mounted() {
		let that = this;
		that.$nextTick(()=> {
            that.topicsListAjax();
        })
    },
    created() {
		
    },
    methods: {
		topicsListAjax(){
            let that = this;
            that.$parent.loadModal(true,'数据加载中...');
            that.$api.get('hotnews/hot-topics/topics-info',{topicId:that.typeId,perpage:that.pageNum,page:that.pageCur},r=>{
                that.$parent.returnCode(r,function(){
                    if(r.data.list.length<=0){
                        that.nodata = true;
                        return
                    }else{
                        that.nodata = false;
                    }
                    that.dataCount = r.data.count;
                    if(that.dataCount>that.pageNum*that.pageCur){
                        that.isShowMore = true;
                    }else{
                        that.isShowMore = false;
                        that.isShowEnd = true;
                    }
                    that.topicsList = that.topicsList.concat(r.data.list);
                });
                that.$parent.loadModal(false);
            });
        },
        showMore(){
            let that = this;
            that.pageCur++;
            if(that.dataCount>((that.pageCur-1)*that.pageNum)){
                that.topicsListAjax();
            }
        }
	}
}
</script>



// WEBPACK FOOTER //
// src/page/hotSpotEvents/specialDetail.vue